module.exports = __webpack_public_path__ + "static/media/02-page1.c9a3cc39.png";